import { render, staticRenderFns } from "./PlatformResQPage.vue?vue&type=template&id=6e07b239&"
import script from "./PlatformResQPage.vue?vue&type=script&lang=js&"
export * from "./PlatformResQPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports